import { AnalyticsProvider } from '@bbld/bbl-analytics'
import { FC } from 'react'
import { IBBL } from 'shared/models/BBL'
import history from 'browserHistory'

interface IProps {
  bbl: IBBL
  children?: React.ReactNode
}

const AnalyticsHandler: FC<IProps> = ({ bbl, children }) => {
  const analyticsSettings = {
    gtmCodes: [window.config.bblPivotalGtmCode],
    siteName: window.config.appName,
    bblCode: window.config.bblCode,
    ngtApp: Boolean(window.ReactNativeWebView),
  }

  if (bbl.settings.gtmId) {
    analyticsSettings.gtmCodes.push('GTM-' + bbl.settings.gtmId)
  }

  return (
    <AnalyticsProvider settings={analyticsSettings} history={history}>
      {children}
    </AnalyticsProvider>
  )
}

export default AnalyticsHandler
